import {decorate, observable} from 'mobx';
import {faThermometer} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class Sensor extends BaseModel {
  static faIcon = faThermometer;
  searchableProperties = ['name', 'label'];
  saveableProperties = [
    'name',
    'label',
    'opcPath',
    'sensorType',
    'hierarchyId',
    'online',
    'isAsync',
    'isManual',
    'enabled',
    'unitOfMeasureId',
  ];

  populateAttributesFromStore(rootStore) {
    this.hierarchy = rootStore.hierarchyStore.getById(this.hierarchyId);
    this.unitOfMeasure = rootStore.unitOfMeasurementStore.getById(this.unitOfMeasureId);
    return super.populateAttributesFromStore(rootStore);
  }

  static prepareApiPayload(model) {
    return {
      ...this.getPlainSaveableObject(model),
      hierarchyId: model.hierarchyId || null,
      unitOfMeasureId: model.unitOfMeasureId || null,
      isAsync: model.isAsync || false,
      isManual: model.isManual || false,
    };
  }
}

decorate(Sensor, {
  id: observable,
  name: observable,
  label: observable,
  opcPath: observable,
  sensorType: observable,
  hierarchyId: observable,
  hierarchy: observable,
  online: observable,
  isAsync: observable,
  isManual: observable,
  enabled: observable,
  unitOfMeasureId: observable,
  unitOfMeasure: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
});

/**
 * sensor type translations:
 * t('sensor.types.DEFAULT')
 * t('sensor.types.SPEED')
 * t('sensor.types.INTERRUPTION')
 * t('sensor.types.GOODS_RECEIPT')
 * t('sensor.types.PRODUCE')
 * t('sensor.types.CONSUME')
 * t('sensor.types.COMPONENT_PREPARE')
 * t('sensor.types.WASTE')
 */
export const SensorTypes = Object.freeze({
  Default: 'DEFAULT',
  // Edit state log
  Interruption: 'INTERRUPTION',
  // Edit operation/order
  Speed: 'SPEED',
  GoodsReceipt: 'GOODS_RECEIPT',
  Waste: 'WASTE',
  // Creates yield
  YieldGr: 'YIELD_GR',
  YieldWaste: 'YIELD_WASTE',
  // Batch queue
  ComponentPrepare: 'COMPONENT_PREPARE',
  Produce: 'PRODUCE',
  Consume: 'CONSUME',
});
